import { render } from "./auth.vue?vue&type=template&id=310d0962&scoped=true&ts=true"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"

import "./auth.vue?vue&type=style&index=0&id=310d0962&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310d0962"]])

export default __exports__